<template>
  <div>
    <header>
      <h1 class="title ">
        <a :href="home"><img :src="require('@/assets/img/logo.png')" alt="" /></a>
        <span>2022明基摄影后期大赛</span>
      </h1>
    </header>
    <div class="content-main">
      <div v-if="voteIntroShow" class="vote-intro">
        <h3>投票说明</h3>
        <div class="vote-intro-content">
          <p><span>①</span>每人每天只有5票，可多次登录投票</p>
          <p><span>②</span>每人每天不得给单幅 参赛作品重复投票</p>
          <p><span>③</span>如发现恶意刷票，取消作者参赛资格</p>
        </div>
      </div>
      <div class='schedule'>人气投票：11月1日-11月30日 </div>
      <!-- <step-tab /> -->
      <div class="search-wrap">
        <i @click="searchEvent"><svg t="1589350342740" viewBox="0 0 1024 1024" version="1.1"
            xmlns="http://www.w3.org/2000/svg" p-id="2244">
            <path
              d="M402.6 56c48.2 0 94.8 9.4 138.8 28 42.5 18 80.6 43.7 113.4 76.4 32.8 32.8 58.5 70.9 76.4 113.4 18.6 43.9 28 90.6 28 138.8s-9.4 94.8-28 138.8c-18 42.5-43.7 80.6-76.4 113.4-32.8 32.8-70.9 58.5-113.4 76.4-43.9 18.6-90.6 28-138.8 28s-94.8-9.4-138.8-28c-42.5-18-80.6-43.7-113.4-76.4C117.7 632 92 593.8 74 551.4c-18.6-43.9-28-90.6-28-138.8s9.4-94.8 28-138.8c18-42.5 43.7-80.6 76.4-113.4 32.8-32.8 70.9-58.5 113.4-76.4 43.9-18.6 90.6-28 138.8-28m0-40C183.6 16 6 193.6 6 412.6s177.6 396.6 396.6 396.6 396.6-177.6 396.6-396.6S621.6 16 402.6 16zM687.4 658.9c-4.5 0-8.9 1.7-12.3 5.1l-3.6 3.6c-6.8 6.8-6.8 17.9 0 24.7l312.9 312.9c3.4 3.4 7.9 5.1 12.3 5.1s8.9-1.7 12.3-5.1l3.6-3.6c6.8-6.8 6.8-17.9 0-24.7L699.7 664c-3.4-3.4-7.9-5.1-12.3-5.1z"
              fill="#dcdfe6" p-id="2245"></path>
          </svg></i>
        <input type="search" v-model="meta.keyword" @keydown.enter="searchEvent" />
      </div>
      <div class="breadcrumb-wrap">
        <div class="left-info">
          <!-- <el-breadcrumb separator-class="el-icon-arrow-right">
            
            <el-breadcrumb-item
              v-for="(item, index) in breadcrumb"
              :key="index"
              @click.native="breadcrumbGotoEvent(item)"
              >{{ item.title }}</el-breadcrumb-item
            >
          </el-breadcrumb> -->
          <div class="works-info" v-if="$route.name === 'WorksDetails'">
            <div>作品分类：{{ worksDetails.workstype }}</div>
            <div v-if="voteIntroShow" class="vote-number">
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-dianzan"></use>
              </svg><span>{{ worksDetails.weekVoteNumber || 0 }}</span>
            </div>
            <div class="view-number">
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-views"></use>
              </svg><span>{{ worksDetails.pageViewNumber || 0 }}</span>
            </div>
          </div>
        </div>

        <div class="select-button" v-if="$route.name !== 'WorksDetails'">
          <works-type-select-tab @change="typeChange" />
        </div>

        <div class="show-tool">
          <div class="more-tool">
            <div class="sort" v-if="$route.name !== 'WorksDetails' && voteIntroShow">
              排序方式：<span @click="sortActiveEvent(0)" :class="{ active: sortActive === 0 }">时间</span>
              <i> | </i>
              <span @click="sortActiveEvent(1)" :class="{ active: sortActive === 1 }">票数</span>
              <!-- <i> | </i> -->
              <!-- <span
                @click="sortActiveEvent(2)"
                :class="{ active: sortActive === 2 }"
                >随机</span
              > -->
            </div>
            <div class="sort" v-if="$route.name !== 'WorksDetails' && !voteIntroShow">
              排序方式：<span @click="sortActiveEvent(0)" :class="{ active: sortActive === 0 }">时间</span>
              <!-- <i> | </i> -->
              <!-- <span
                @click="sortActiveEvent(2)"
                :class="{ active: sortActive === 2 }"
                >随机</span
              > -->
            </div>
            <div v-if="voteIntroShow" class="selected">
              <el-badge :value="selectedArr.length" class="item">
                <svg class="icon" aria-hidden="true">
                  <use xlink:href="#icon-selected"></use>
                </svg>
              </el-badge>
              <span>已选</span>
            </div>
            <BaseButton v-if="$route.name !== 'WorksDetails' && voteIntroShow" :disable='disable' @click="voteEvent">投票
            </BaseButton>
          </div>
          <!-- <div class="share-wrap" v-if="$route.name === 'WorksDetails'">
            <div class="share-text">点击分享:</div>
            <el-popover placement="bottom" width="200" trigger="hover">
              <div class="qrcode"></div>
              <div
                class="share-icon"
                @click="shareEvent('wechat')"
                slot="reference"
                :style="{
                  backgroundImage: `url(${require(`@/assets/img/share/${'wechat'}.png`)})`,
                }"
              ></div>
            </el-popover>
            <div
              v-for="(item, index) in shareIcon"
              :key="index"
              class="share-icon"
              :class="{ 'copy-url': item === 'url' }"
              @click="shareEvent(item)"
              :style="{
                backgroundImage: `url(${require(`@/assets/img/share/${item}.png`)})`,
              }"
            ></div>
          </div> -->
        </div>
      </div>

      <router-view class='route' ref="route"></router-view>
    </div>

  </div>
</template>
<script>
import { mapState, mapGetters, mapMutations } from "vuex";
import ClipboardJS from "clipboard";
import worksApi from "@/api/works";
import WorksTypeSelectTab from "./WorksTypeSelectTab.vue";
import StepTab from "./StepTab.vue";

let clip;

export default {
  components: { WorksTypeSelectTab, StepTab },
  name: "WorksWrapMain",
  data() {
    return {
      home: process.env.VUE_APP_HOME,
      meta: {
        keyword: "",
        currentPage: 1,
      },
      shareIcon: ["weibo", "url"],
      radio: "相机赛区",
      voteIntroShow: true,
      disable: new Date().getTime() < new Date('2022.11.01').getTime()
    };
  },
  computed: {
    ...mapState([
      "breadcrumb",
      "sortActive",
      "selectedArr",
      "worksDetails",
      "imgListNum",
      "searchWorksType",
      "radioText",
    ]),
  },
  watch: {},
  methods: {
    ...mapMutations(["setSortActive", "setSearchWorksType"]),
    /**
     * 面包屑事件
     */
    breadcrumbGotoEvent(item) {
      if (item.url) {
        this.$router.push(item.url);
      }
    },
    /**
     * 搜索事件
     */
    searchEvent() {
      let that = this;
      this.meta.currentPage = 1;
      this.$router.push({ path: `/works/${that.$route.params.type}`, query: this.meta });
    },
    /**
     * 生成二维码
     */
    createQRCodeFn() {
      let box = document.querySelector(".qrcode");
      if (box) {
        new QRCode(box, {
          text: location.href,
          width: 200,
          height: 200,
          colorDark: "#000000",
          colorLight: "#ffffff",
          correctLevel: QRCode.CorrectLevel.H,
        });
      }
    },
    /**
     * 分享
     */
    shareEvent(type) {
      if (type === "wechat" || type === "friends") {
      } else if (type === "weibo") {
        this.$root.$emit("weibo");
      }
    },
    /**
     * 初始化复制链接
     */
    initCopyUrlFn() {
      let _this = this;
      this.$nextTick(() => {
        if (clip) {
          return;
        }
        clip = new ClipboardJS(".copy-url", {
          text: function (trigger) {
            _this.$message.success("链接复制成功");
            return location.href;
          },
        });
      });
    },
    /**
     * 设置排序方法
     */
    sortActiveEvent(val) {
      if (this.sortActive != val) {
        this.setSortActive(val);
        this.$refs.route.$children[0].fetchData(true);
      }
    },
    /**
     * 投票
     */
    async voteEvent() {
      if (!!window.ActiveXObject || "ActiveXObject" in window) {
        this.$message.warning("暂不支持使用IE浏览器投票");
        return;
      }

      if (this.selectedArr.length === 0) {
        this.$message.warning("您还没有选择作品");
        return;
      }
      let token = localStorage.getItem("token");
      if (token) {
        let { code, msg } = await worksApi.voteWorks(this.selectedArr, token);
        if (code === 200) {
          this.$message.success("投票成功");

          this.$refs.route.$children[0].clearSelectedFn();
        } else if (code === 201) {
          this.$message.warning(msg);
          this.$refs.route.$children[0].clearSelectedFn();
        } else if (code === 4018) {
          localStorage.removeItem("token");
        }
      } else {
        window.open(
          "/syhqds2022/wechat-login.html",
          "_blank",
          "width=700, height=500, left=200"
        );
      }
    },
    typeChange() {
      this.$refs.route.$children[0].fetchData(true);
    },
  },
  mounted() {
    this.createQRCodeFn();
    // this.initCopyUrlFn();
  },
  created() {
    require('../../utils/setRootVlalue')
    this.meta = {
      keyword: this.$route.query.keyword || "",
      currentPage: this.$route.query.currentPage || 1,
    };
  },
};
</script>
<style lang="scss" scoped>
.content-main {
  width: 1614px;
  margin: 0 auto;
}

header {
  height: 60px;
  margin: 0 auto;
  background: $color-bg-black;

  >h1 {
    height: 100%;
    display: flex;
    align-items: center;
    padding: 0 90px;

    img {
      display: block;
      width: 90px;
      height: 25px;
    }

    span {
      color: #fff;
      width: calc(100% - 90px);
      text-align: right;
      font-size: 24px;
      font-family: fangzhengzhengzhongheiti;
    }
  }
}

.schedule {
  font-size: 20px;

  margin: 10px 0 10px 150px;
}

.vote-intro {
  margin-top: 30px;
  height: 88px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  padding: 0 7px;

  h3 {
    margin-left: 35px;
    width: 41px;
    height: 44px;
    font-size: 20px;
    line-height: 24px;
    color: $color-text-primary;
    font-weight: bold;
  }

  .vote-intro-content {
    margin-left: 60px;
    display: flex;

    p {
      font-size: 16px;
      color: $color-text-primary;

      &+p {
        margin-left: 30px;
      }

      >span {
        font-size: 20px;
        margin-right: 6px;
      }
    }
  }
}

.search-wrap {
  margin: 30px auto 0;
  position: relative;
  padding: 0 7px;

  >input {
    padding: 0 10px 0 40px;
    width: 240px;
    height: 30px;
    border-radius: 15px;
    border: solid 1px $color-border-base;
    font-size: 14px;
    box-sizing: border-box;
    color: $color-text-regular;

    &::-webkit-search-cancel-button {
      display: none;
    }
  }

  >i {
    display: inline-block;
    position: absolute;
    top: 5px;
    left: 14px;
    width: 20px;
    height: 20px;
  }
}

.breadcrumb-wrap {
  margin: 25px auto 20px;
  display: flex;
  align-items: center;
  padding-left: 7px;
  padding-right: 7px;

  // justify-content: space-between;
  ::v-deep .el-breadcrumb__item {
    line-height: normal;
    font-size: 16px;
    cursor: pointer;

    a {
      font-weight: normal;
    }
  }

  ::v-deep .el-breadcrumb__separator {
    vertical-align: -1px;
    color: $color-text-primary;
  }

  ::v-deep .el-breadcrumb__item:last-child {
    cursor: default;

    .el-breadcrumb__inner {
      font-weight: bold;
    }
  }

  .share-wrap {
    display: flex;
    align-items: center;

    .share-text {
      font-size: 16px;
      color: $color-text-primary;
      margin-right: 5px;
    }

    .share-icon {
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
      cursor: pointer;
      width: 24px;
      height: 24px;
      margin-left: 10px;
    }
  }

  .qrcode {
    box-shadow: 0 0 0 #000000;
  }
}

.left-info {
  display: flex;
  font-size: 16px;
  color: $color-text-regular;

  >.works-info {
    margin-left: 35px;
    display: flex;
  }

  .view-number,
  .vote-number {
    margin-left: 30px;
    height: 24px;
    display: flex;
    align-items: center;

    svg {
      width: 26px;
      height: 24px;
    }

    span {
      margin-left: 6px;
      margin-bottom: 1px;
    }
  }
}

.select-button {
  margin-left: 40px;
  // ::v-deep span {
  //   width: 70px;
  //   height: 30px;
  //   padding: 0;
  //   line-height: 30px;
  //   font-size: 13px;
  // }
}

.show-tool {
  margin-left: auto;
  margin-right: 0;
  display: flex;
}

.more-tool {
  display: flex;
  align-items: center;
  height: 24px;

  >.sort {
    font-size: 16px;
    color: $color-text-primary;
    margin-right: 36px;

    span {
      cursor: pointer;
      color: $color-text-regular;

      &.active {
        color: $color-primary;
        font-weight: bold;
      }
    }

    i {
      color: $color-text-regular;
      vertical-align: 1px;
    }
  }

  >.selected {
    font-size: 16px;
    // vertical-align: -8px;
    display: flex;
    align-items: center;
    color: $color-primary;
    margin-right: 14px;

    svg {
      width: 24px;
      height: 32px;
      vertical-align: -4px;

      >path {
        fill: $color-primary;
      }
    }

    span {
      margin-left: 8px;
    }

    ::v-deep .el-badge__content.is-fixed {
      top: 4px;
      right: 14px;
    }

    ::v-deep .el-badge__content {
      background-color: #d4003b;
    }
  }
}
</style>